<div *ngIf="message" [ngClass]="{ 'fade-in': 1, 'alert': message, 'alert-success': message.type === 'success', 'alert-danger': message.type === 'error' }">{{message.text}}</div>
